import { ShopkeeperUpdateCheckResponse } from './../../shared/models/shopkeeper/shopkeeper-update-chek-response.type';
import { ShopkeeperUpdateBody } from './../../shared/models/shopkeeper/shopkeeper-update-body.type';
import { Injectable } from '@angular/core';
import { ShopkeeperRestService } from './shopkeeper-rest.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShopkeeperService {
  constructor(private readonly shopkepperRestService: ShopkeeperRestService) {}

  public checkShopkeeper(
    id: string
  ): Observable<ShopkeeperUpdateCheckResponse> {
    return this.shopkepperRestService.get(`merchant/${id}/check`);
  }

  public updateShopkepper(
    id: string,
    data: ShopkeeperUpdateBody
  ): Observable<ShopkeeperUpdateCheckResponse> {
    return this.shopkepperRestService.put(`merchant/${id}`, data);
  }
}
